//#region
import { useState, useEffect } from 'react';
//material
import { Grid, FormControl,Typography, InputLabel, Select as MSelect, MenuItem, Checkbox, ListItemText } from '@mui/material';
// component
import Controls from '../../controls/Controls';
import { useForm, Form } from "../../useForm";
import {ReactComponent as AngleDownIcon } from '../../../assets/icons/icon-angle-down.svg';
import { getUserType } from '../../../config/services/usertype';
//#endregion

const initialFValues = {
  _id: 0,
  roleName: ''
}


export default function PublishedDasboardPopup(props) {
  const { addOrEdit, recordForEdit, setOpenPopup, submitHandler } = props
  const [userTypeList, setUserTypeList] = useState([]);
  const [userTypeAccess, setUserTypeAccess] = useState([]);

  const fetchUserTypeList = () => {
    let params = { pageNo: 0 }
    getUserType(params).then((res) => {
      setUserTypeList([...res?.result]);
    });
  }

  const setUserTypeAccessHandler = (e) => {
    const { value } = e?.target;
    setUserTypeAccess(value)
  }

  useEffect(() => {
    fetchUserTypeList();
  }, []);

  const setUserTypeValueInital = (value) => {
    if (value) {
      setUserTypeAccess(value)
    }
  }

   const getUserTypeId = (namelist) => {
        let userTypeListA = namelist?.map((obj) => {
            let searchObj = userTypeList.find(d => d['userTypeName'] === obj)
            if (searchObj?._id)
                return searchObj._id;
            else
                return null
        })
        let userTypeListIds = userTypeListA.filter((obj) => obj);
        return userTypeListIds;
    }
    

  useEffect(() => {
    setUserTypeValueInital(recordForEdit?.sharedUserType);
  }, [recordForEdit])

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('roleName' in fieldValues) {
      temp.roleName = fieldValues.roleName ? "" : "This field is required."
    }
    
    setErrors({
      ...temp
    })
      
    if (fieldValues === values)
      return Object.values(temp).every(x => x === "")
  }

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm
  } = useForm(initialFValues, true, validate);

  const handleSubmit = e => {
    e.preventDefault()
    submitHandler({ userTypeId:  userTypeAccess?.length ? getUserTypeId(userTypeAccess):[], publishedDashboardAccess: [recordForEdit?._id] })
  }
  
  useEffect(() => {
    if (recordForEdit != null)
      setValues({
        ...recordForEdit
      })
  }, [recordForEdit, setValues])


  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={8}>
          <FormControl variant="outlined" sx={{ m: 1, width: 120 }}>
           <Typography variant="body2" component="p" color="textSecondary" className='text-small label'>Share with</Typography>
                <FormControl variant="outlined" className="report-form-label" sx={{ width: "100%" }}>
                    <MSelect
                        className="report_form_ui_input_select pl-0 text-smal"
                        multiple
                        IconComponent={AngleDownIcon}
                        value={userTypeAccess}
                        renderValue={(selected) => selected.join(", ")}
                        onChange={(e) => setUserTypeAccessHandler(e)}
                        MenuProps={{
                            anchorOrigin: {
                              vertical: "bottom",
                              horizontal: "left"
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left"
                            },
                            getContentAnchorEl: null
                        }}
                    >
                        {
                            userTypeList?.map((data) => (
                                <MenuItem className='menu-item-small' key={data?._id} value={data?.userTypeName}>
                                    <Checkbox className="form_checkbox" checked={userTypeAccess?.indexOf(data?.userTypeName) > -1} />
                                    <ListItemText className="text-small" primary={data?.userTypeName} />
                                </MenuItem>
                            ))
                        }
                    </MSelect>
                </FormControl>
                
          </FormControl>
        </Grid>
        
        <Grid item xs={8}>
          <div>
            <Controls.Button
              type="submit"
              text="submit"
              onClick={handleSubmit}
            />
            <Controls.Button
              color="secondary"
              text="Cancel"
              onClick={e => setOpenPopup(false)}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  )
}